<template>
  <header class="header">
    <div class="header-content">
      <el-row>
        <el-col :span="24">
          <div class="logo"><a href="/"><img src="../assets/images/logo.png" height="32px" width="125px"/></a></div>
        </el-col>
      </el-row>
    </div>
  </header>
</template>

<script>
import SearchIpt from './SearchIpt'
let $ = require('jQuery')

export default {
  name: 'Header',
  components: {
    searchIpt: SearchIpt
  },
  created() {
    setTimeout(() => {
      $('#app').addClass('use-mobile-style')
    })
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  max-width: 2560px;
  margin: 0 auto;
  padding: 40px 0 60px;

  .logo {
    text-align: center;
    height: 32px;
    a {
      display: inline-block;
      height:32px;
      font-size:26px;
      font-family:Impact;
      color:rgba(0,0,0,1);
      line-height:31px;
    }
  }
}
@media (max-width: 1024px) {
  .header {
    padding: 20px 0 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderSimple.vue